// src/components/PeoplePlan/EmployeeManagement/hooks/useEmptyPositionSelection.js
import { useState } from 'react';

export const useEmptyPositionSelection = () => {
  const [selectedEmptyPositions, setSelectedEmptyPositions] = useState([]);

  const handleEmptyPositionSelect = (positionKey, storeCorp, roleType) => {
    setSelectedEmptyPositions((prev) => {
      if (prev.includes(positionKey)) {
        return prev.filter((key) => key !== positionKey);
      } else {
        return [...prev, positionKey];
      }
    });
  };

  const clearEmptyPositions = () => {
    setSelectedEmptyPositions([]);
  };

  const isPositionSelected = (positionKey) => {
    return selectedEmptyPositions.includes(positionKey);
  };

  return {
    selectedEmptyPositions,
    handleEmptyPositionSelect,
    clearEmptyPositions,
    isPositionSelected,
    emptyPositionCount: selectedEmptyPositions.length,
  };
};